import React from "react";
import { useParams } from "react-router-dom";
import PaymentFailedWrapperArea from "./PaymentFailedWrapperArea";

function PaymentFailed() {

  const { ctype } = useParams(); // mode will be "online" or "onsite"
  const { hash } = useParams(); // hash is the unique booking hash

  return (
    <>
      <PaymentFailedWrapperArea ctype={ctype} hash={hash} />
    </>
  );
}

export default PaymentFailed;
